(() => {
  'use strict';
  const root = window.FM?.root || '/';
  const money = cents => new Intl.NumberFormat('fr-FR', {style:'currency', currency:window.FM?.currency || 'EUR'}).format(cents / 100);
  const drawer = document.getElementById('fm-cart');
  const lines = drawer?.querySelector('[data-fm-cart-items]');
  const status = drawer?.querySelector('[data-fm-cart-status]');
  let busy = false;
  let opener = null;
  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  async function api(path, payload) {
    const response = await fetch(root + path, payload ? {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify(payload)} : {headers:{Accept:'application/json'}, cache:'no-store'});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Une erreur est survenue. Veuillez réessayer.');
    return data;
  }
  function renderCart(cart) {
    if (!drawer || !lines) return;
    lines.replaceChildren();
    for (const item of cart.items) {
      const row = el('article','fm-cart__line');
      const image = el('img'); image.src = item.image || ''; image.alt = item.product_title; image.width = image.height = 78;
      const body = el('div');
      const link = el('a','',item.product_title); link.href = item.url; body.append(link);
      if (item.variant_title && item.variant_title !== 'Default Title') body.append(el('p','',item.variant_title));
      if (item.properties) for (const [key,value] of Object.entries(item.properties)) if (value && !key.startsWith('_')) body.append(el('p','',`${key} : ${value}`));
      const bottom = el('div','fm-cart__row');
      const quantity = el('div','fm-cart__quantity');
      for (const [label,delta] of [['−',-1],['+',1]]) {
        const button=el('button','',label);button.type='button';button.dataset.fmLine=item.key;button.dataset.fmVariant=String(item.variant_id);button.dataset.fmQuantity=String(item.quantity+delta);button.setAttribute('aria-label',`${delta<0?'Diminuer':'Augmenter'} la quantité de ${item.product_title}`);
        if (delta<0) quantity.append(button,el('span','',String(item.quantity))); else quantity.append(button);
      }
      bottom.append(quantity,el('strong','',money(item.final_line_price)));body.append(bottom);
      const remove=el('button','fm-cart__remove','Retirer');remove.type='button';remove.dataset.fmLine=item.key;remove.dataset.fmVariant=String(item.variant_id);remove.dataset.fmQuantity='0';remove.setAttribute('aria-label',`Retirer ${item.product_title}`);body.append(remove);
      row.append(image,body);lines.append(row);
    }
    if (!cart.items.length) lines.append(el('p','fm-cart__empty','Votre panier est vide. Découvrez nos coffrets pour commencer.'));
    drawer.querySelector('[data-fm-cart-total]').textContent=money(cart.total_price);
    drawer.querySelector('[data-fm-checkout]').disabled=!cart.items.length;
    document.querySelectorAll('[data-fm-count]').forEach(node=>{node.textContent=cart.item_count;node.hidden=!cart.item_count;});
  }
  async function syncGifts(cart) {
    const gifts=window.FM_GIFTS;
    if (!gifts) return cart;
    const has = handle => cart.items.some(i=>i.handle===handle);
    const bundle=cart.items.some(i=>['le-cadeau-malin','le-cadeau-inoubliable','coffret-de-noel-filou-moustache','planche-led-filou-moustache'].includes(i.handle));
    const tree=has('sapin-feutrine-filou-moustache');
    const magic=has('le-cadeau-magique');
    const wanted={};
    wanted[gifts.defis]=bundle?1:0;
    wanted[gifts.eveil]=(bundle || magic || cart.items.some(i=>i.handle==='sapin-feutrine-filou-moustache' && /2 sapins/.test(i.variant_title||'')))?1:0;
    wanted[gifts.avent]=(tree || magic || has('coffret-de-noel-filou-moustache'))?1:0;
    wanted[gifts.etoiles]=cart.items.reduce((sum,i)=>sum+(i.handle==='sapin-feutrine-filou-moustache'?i.quantity*(/2 sapins/.test(i.variant_title||'')?2:1):i.handle==='le-cadeau-magique'?i.quantity:0),0);
    const updates={};
    for (const [id,quantity] of Object.entries(wanted)) {
      if (!id || id==='undefined') continue;
      const current=cart.items.filter(i=>String(i.variant_id)===id).reduce((sum,i)=>sum+i.quantity,0);
      if (current!==quantity) updates[id]=quantity;
    }
    return Object.keys(updates).length ? await api('cart/update.js',{updates}) : cart;
  }
  async function refresh() {const cart=await syncGifts(await api('cart.js'));renderCart(cart);return cart;}
  function showCart(trigger) {if(!drawer)return;opener=trigger||document.activeElement; if(!drawer.open)drawer.showModal();document.documentElement.style.overflow='hidden';}
  function closeCart(){drawer?.close();document.documentElement.style.overflow='';opener?.focus();}
  document.addEventListener('click',async event=>{
    const open=event.target.closest('[data-fm-open-cart]');
    if(open){event.preventDefault();showCart(open);try{await refresh();}catch(error){status.textContent=error.message;}return;}
    if(event.target.closest('[data-fm-close-cart]')){closeCart();return;}
    const change=event.target.closest('[data-fm-line]');
    if(change){
      if(busy)return;busy=true;status.textContent='';
      drawer.querySelectorAll('[data-fm-line]').forEach(b=>b.disabled=true);
      try{const cart=await syncGifts(await api('cart/change.js',{id:change.dataset.fmLine,quantity:Number(change.dataset.fmQuantity)}));renderCart(cart);}catch(error){
        // An installed cart app may already have removed the line before its response returns.
        const cart=await refresh().catch(()=>null);
        const removed=Number(change.dataset.fmQuantity)===0 && cart && !cart.items.some(item=>String(item.variant_id)===change.dataset.fmVariant);
        status.textContent=removed?'':error.message;
      }finally{busy=false;}
    }
  });
  drawer?.addEventListener('cancel',event=>{event.preventDefault();closeCart();});
  drawer?.addEventListener('click',event=>{if(event.target===drawer){const r=drawer.getBoundingClientRect();if(event.clientX<r.left)closeCart();}});
  document.addEventListener('submit',async event=>{
    const form=event.target;
    if(!(form instanceof HTMLFormElement) || !/\/cart\/add\/?$/.test(new URL(form.action,location.href).pathname))return;
    event.preventDefault();
    if(busy)return;
    const button=form.querySelector('[type=submit]');const original=button?.textContent;
    const data=new FormData(form);const id=Number(data.get('id'));
    const expected=Number(button?.dataset.variantId);
    if(!id || (expected && id!==expected)){
      form.querySelector('.fm-error')?.remove();
      const note=el('p','fm-error','Veuillez choisir à nouveau votre formule avant de l’ajouter au panier.');
      note.setAttribute('role','alert');form.append(note);return;
    }
    busy=true;if(button){button.disabled=true;button.setAttribute('aria-busy','true');button.textContent='Ajout en cours…';}
    form.querySelector('.fm-error')?.remove();
    const item={id,quantity:Math.max(1,Number(data.get('quantity'))||1),properties:{}};
    for(const [key,value] of data.entries()){const match=key.match(/^properties\[(.+)\]$/);if(match)item.properties[match[1]]=value;}
    const items=[item];const extra=Number(data.get('fm_extra'));if(extra)items.push({id:extra,quantity:1});
    try{
      await api('cart/add.js',{items});
      await refresh();status.textContent='';showCart(button);if(button)button.textContent='✓ Ajouté';
      document.dispatchEvent(new CustomEvent('fm:cart-updated'));
    }catch(error){const note=el('p','fm-error',error.message);note.setAttribute('role','alert');form.append(note);}
    finally{busy=false;if(button){button.disabled=false;button.removeAttribute('aria-busy');button.textContent=original;}}
  });
  document.querySelectorAll('[data-fm-variant-select]').forEach(select=>{
    select.addEventListener('change',()=>{
      const option=select.selectedOptions[0];const section=select.closest('[data-fm-product]');
      section.querySelector('[data-fm-product-price]').textContent=money(Number(option.dataset.price));
      const compare=section.querySelector('[data-fm-product-compare]');compare.textContent=money(Number(option.dataset.compare));compare.hidden=Number(option.dataset.compare)<=Number(option.dataset.price);
      const button=section.querySelector('[type=submit]');button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?'Indisponible':'Ajouter au panier';
      const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);
      if(option.dataset.image){const img=section.querySelector('[data-fm-main-image]');img.src=option.dataset.image;img.removeAttribute('srcset');}
    });
  });
  window.fmOpenCart=showCart;
})();
